<template>
  <div>
    <!-- add event modal  -->
    <!-- editDialog -->
    <v-dialog v-model="editDialog" max-width="600">
      <v-card>
        <div
          class="close-btn"
          :class="locale == 'en' ? 'text-right' : 'text-left'"
        >
          <v-btn class="mt-2" color text @click="closeEditDialog()">
            <v-icon class="main-color">close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="headline main-color mt-2">{{
          $t("editAppointment")
        }}</v-card-title>

        <div>
          <v-container>
            <div v-if="scheduleMessage != ''" style="text-align: center">
              <p class="alert" style="color: red">{{ scheduleMessage }}</p>
            </div>
            <v-row>
              <v-col cols="12" sm="12">
                <v-menu
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <label for="date">{{ $t("theDate") }} *</label>
                    <v-text-field
                      v-model="event.date"
                      prepend-inner-icon="event"
                      :rules="[validationRules.required]"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="event.date"
                    @input="menu3 = false"
                    :min="nowDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="event.start"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <label for="from">{{ $t("from") }} *</label>
                    <v-text-field
                      v-model="event.start"
                      prepend-inner-icon="access_time"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      solo
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu2"
                    v-model="event.start"
                    full-width
                    @click:minute="$refs.menu2.save(event.start)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="event.end"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <label for="to">{{ $t("to") }} *</label>
                    <v-text-field
                      v-model="event.end"
                      prepend-inner-icon="access_time"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      solo
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu1"
                    v-model="event.end"
                    full-width
                    @click:minute="$refs.menu1.save(event.end)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="modal-btn text-center">
            <v-col cols="2"></v-col>
            <v-col cols="4">
              <v-btn
                class="primary-btn"
                text
                @click="updateEvent"
                :loading="loading"
                :disabled="loading"
                >{{ $t("Update") }}</v-btn
              >
            </v-col>
            <v-col cols="4">
              <v-btn class="danger-btn" text @click="deleteEvent">{{
                $t("Delete")
              }}</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from "../mixins/validationMixin";

export default {
  name: "editTeacherEvents",
  mixins: [validationMixin],

  props: ["editDialog", "eventObject"],
  data() {
    return {
      loading: false,
      scheduleMessage: "",
      nowDate: new Date(Date.now()).toISOString().slice(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      events: [],
      event: {},
      selectedId: ""
    };
  },
  watch: {
    eventObject: {
      handler() {
        if (this.eventObject) {
          this.event.date = this.eventObject.date;
          this.event.start = this.eventObject.start_time;
          this.event.end = this.eventObject.end_time;
          this.event.is_request = this.eventObject.is_request;

          this.selectedId = this.eventObject.id;
        }
      }
    }
  },
  methods: {
    closeEditDialog() {
      this.event = {
        start: null,
        end: null,
        date: new Date().toISOString().substr(0, 10),
        is_request: false
      };
      this.scheduleMessage = "";
      this.$emit("dialogClosed");
    },
    updateEvent() {
      if (this.event.is_request) {
        if (confirm(this.$i18n.t("update_event_message"))) {
          this.loading = true;
          this.$http
            .post(
              this.getApiUrl + "/teacher/schedule/update/" + this.selectedId,
              this.event,
              {
                headers: {
                  Authorization: "Bearer " + localStorage.token,
                  locale: this.locale
                }
              }
            )
            .then(response => {
              this.loading = false;
              if (response.data.status.error) {
                this.scheduleMessage = response.data.status.message;
              } else {
                this.$emit(
                  "updated",
                  response.data.status.error,
                  response.data.status.message
                );
                this.closeEditDialog();
              }
            });
        }
      } else {
        this.loading = true;
        this.$http
          .post(
            this.getApiUrl + "/teacher/schedule/update/" + this.selectedId,
            this.event,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
                locale: this.locale
              }
            }
          )
          .then(response => {
            this.loading = false;
            if (response.data.status.error) {
              this.scheduleMessage = response.data.status.message;
            } else {
              this.$emit(
                "updated",
                response.data.status.error,
                response.data.status.message
              );
              this.closeEditDialog();
            }
          });
      }
    },
    deleteEvent() {
      if (this.event.is_request) {
        if (confirm(this.$i18n.t("update_event_message"))) {
          this.$http
            .get(
              this.getApiUrl + "/teacher/schedule/delete/" + this.selectedId,
              {
                headers: {
                  Authorization: "Bearer " + localStorage.token,
                  locale: this.locale
                }
              }
            )
            .then(response => {
              this.$emit(
                "updated",
                response.data.status.error,
                response.data.status.message
              );
              this.closeEditDialog();
            });
        }
      } else {
        if (confirm(this.$i18n.t("delete_event_message"))) {
          this.$http
            .get(
              this.getApiUrl + "/teacher/schedule/delete/" + this.selectedId,
              {
                headers: {
                  Authorization: "Bearer " + localStorage.token,
                  locale: this.locale
                }
              }
            )
            .then(response => {
              this.$emit(
                "updated",
                response.data.status.error,
                response.data.status.message
              );
              this.closeEditDialog();
            });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
